import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import { store } from './redux/store';

import swDevs from './swDevs';

import OfflinePopUp from './components/offlinePopUp/OfflinePopUp';
const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <Provider store={store}  >
    <App />
    {/* <OfflinePopUp /> */}
  </Provider>
);

swDevs()
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
